var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "bg-base" }, [
      _c(
        "div",
        { staticClass: "pt-60 pb-120 pt-md-100 pb-md-200 position_relative" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "el_headingA", attrs: { title: "About Us" } },
            [_vm._v("\n                由数学について\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "contA mt-60 mt-md-100" }, [
            _c("p", { ref: "parallaxA", staticClass: "contA_txt" }, [
              _c("span", [
                _vm._v(
                  "\n                        由数学とは、新しいコミュニケーションツールを提供するプロファイリングメソッドです。\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n                        なぜいま、由数学が必要なのでしょうか？\n                    "
                ),
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n                        自分または相手の在り方・考え方・行動パターンなどを具体的に個人分析し、理解することで、コミュニケーション・ビジネス・子育てと、様々な場面で円滑な人間関係が構築できます。\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n                        「風の時代」と言われる今、個を大切にし、互いを理解し合えるメソッド。それが由数学なのです。\n                    "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "contA_imgWrap" }, [
              _c("img", {
                staticClass: "contA_img",
                attrs: {
                  src: _vm.dir + "/src/assets/img/yusuugaku-hands@2x.webp",
                  alt: "",
                },
              }),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        {
          staticClass:
            "container pt-60 pb-60 pt-md-100 pb-md-100 position_relative",
        },
        [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "el_headingA", attrs: { title: "Philosophy" } },
            [_vm._v("\n                由数学3つの概念\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cardBUnit" }, [
            _c("div", { staticClass: "cardB js_inview_cardB" }, [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "cardB_diagonalLine",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "59.688",
                    height: "56.725",
                    viewBox: "0 0 59.688 56.725",
                  },
                },
                [
                  _c("line", {
                    staticClass: "js_inview_cardB_line",
                    attrs: {
                      "data-name": "line",
                      x1: "59",
                      y2: "56",
                      transform: "translate(0.344 0.363)",
                      fill: "none",
                      stroke: "#1e2e40",
                      "stroke-width": "1",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm._m(5),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cardB js_inview_cardB" }, [
              _vm._m(6),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "cardB_diagonalLine",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "59.688",
                    height: "56.725",
                    viewBox: "0 0 59.688 56.725",
                  },
                },
                [
                  _c("line", {
                    staticClass: "js_inview_cardB_line",
                    attrs: {
                      "data-name": "line",
                      x1: "59",
                      y2: "56",
                      transform: "translate(0.344 0.363)",
                      fill: "none",
                      stroke: "#1e2e40",
                      "stroke-width": "1",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm._m(7),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cardB js_inview_cardB" }, [
              _vm._m(8),
              _vm._v(" "),
              _c(
                "svg",
                {
                  staticClass: "cardB_diagonalLine",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "59.688",
                    height: "56.725",
                    viewBox: "0 0 59.688 56.725",
                  },
                },
                [
                  _c("line", {
                    staticClass: "js_inview_cardB_line",
                    attrs: {
                      "data-name": "line",
                      x1: "59",
                      y2: "56",
                      transform: "translate(0.344 0.363)",
                      fill: "none",
                      stroke: "#1e2e40",
                      "stroke-width": "1",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "cardB_txt js_inview_cardB_txt" }, [
                _vm._v(
                  "\n                        由数学では、カウンセラーとして活動していく中で多くの方の悩みを解決し人や社会に貢献し、同じ思いを持った仲間とともに確実に収益化しながら、喜びと感謝溢れる毎日を構築します。\n                    "
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm._m(9),
    _vm._v(" "),
    _c("section", [
      _c(
        "div",
        {
          staticClass:
            "container pt-60 pb-200 pt-md-100 pb-md-250 position_relative",
        },
        [
          _vm._m(10),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "el_headingA", attrs: { title: "Pre-seminar" } },
            [_vm._v("\n                体験セミナー\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "contD mt-60" }, [
            _vm._m(11),
            _vm._v(" "),
            _vm._m(12),
            _vm._v(" "),
            _vm._m(13),
            _vm._v(" "),
            _c("p", { staticClass: "mt-15" }, [
              _vm._v("※開催日時は、お申し込み欄に記載しています。"),
            ]),
            _vm._v(" "),
            _vm._m(14),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "d_flex justify_content_center mt-50" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "el_btnA el_btnA__black el_btnA__large",
                    attrs: { to: "/entry-pre-seminar" },
                  },
                  [
                    _vm._v(
                      "\n                        ENTRY\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "bg-base" }, [
      _c(
        "div",
        {
          staticClass:
            "container pt-60 pb-200 pt-md-100 pb-md-250 position_relative",
        },
        [
          _vm._m(15),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "el_headingA", attrs: { title: "Message" } },
            [_vm._v("\n                受講生の声\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contE mt-60" },
            [
              _c(
                "swiper",
                {
                  staticClass: "contEUnit",
                  attrs: { options: _vm.swiperOption },
                },
                [
                  _c("swiper-slide", { staticClass: "cardE" }, [
                    _c("div", { staticClass: "cardE_body" }, [
                      _c("p", { staticClass: "cardE_txtA" }, [
                        _vm._v(
                          "\n                                私は普段から仕事でカウンセリングをやる機会があり、個人で事業をするなら人にカウンセリングを通して背中を押す事ができるといいな〜と思っていました。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                由数学のお話を頂いた時、初めはどんなカウンセリングするのか想像もつきませんでした。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                そこで、やるかやらないか別としてまずはプレセミナーに参加する事にしました。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                プレセミナーに参加した事で、由数学とは…から全体概要、由数学がこれからの時代に求められる選ばれるカウンセリングの仕事である事を確信しました。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                人の生まれ持った個性にフォーカスして、個々に合わせた暮らし方や対人関係、仕事のアドバイスができる由数学は、まさにサスティナブルな社会の実現にふさわしいとも思います。\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "cardE_txtB" }, [
                        _vm._v("沖縄県　M.Kさん"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("swiper-slide", { staticClass: "cardE" }, [
                    _c("div", { staticClass: "cardE_body" }, [
                      _c("p", { staticClass: "cardE_txtA" }, [
                        _vm._v(
                          "\n                                私はこれがしたい、あれがしたい。本当に明確な目標などはありませんでした。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                ただ由数学のプレセミナーに参加して「これってみんなが知ったらすごくストレスフリーに暖かい世の中になるな」と思いました。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                人間関係身近だったり、仕事だったら必ず誰しもが悩んだことがあることだと思います。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                考え方が変わる、人をさらに好きになる学問だと思います。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                参加して学んでみて良かったです。\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "cardE_txtB" }, [
                        _vm._v("広島県　A.Kさん"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("swiper-slide", { staticClass: "cardE" }, [
                    _c("div", { staticClass: "cardE_body" }, [
                      _c("p", { staticClass: "cardE_txtA" }, [
                        _vm._v(
                          "\n                                由数学って初めて聞くけどなんだろう？"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                怪しかったらどうしよう？"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                そんな半信半疑のスタートでした。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                しかし参加してみると、"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                えっ！そういうこと！？"
                        ),
                        _c("br"),
                        _vm._v("\n                                わかるー！"),
                        _c("br"),
                        _vm._v(
                          "\n                                驚きと共感の連続。あっという間の2時間でした。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                職場における同僚や上司、取引先との人間関係の作り方。人との距離の取り方。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                子育てにおける悩み。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                いつも他人と比べ自己肯定感の低い自分の性格。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                なんでいつも自分はこうなんだろう…。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                全ての人間のお悩み解決法がこの由数学にある！と思いました。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                学び伝えることで大切な人も自分も幸せにできる。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                由数学はまさに人間学。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                この世界の誰もが抱える、生き方のヒントが見つかる学問だと思います。\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "cardE_txtB" }, [
                        _vm._v("広島県　H.Tさん"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-pagination",
                    attrs: { slot: "pagination" },
                    slot: "pagination",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(16),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "d_flex justify_content_center mt-50" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "el_btnA el_btnA__black el_btnA__large",
                      attrs: { to: "/entry-pre-seminar" },
                    },
                    [
                      _vm._v(
                        "\n                        ENTRY\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "bg-base" }, [
      _c("div", { staticClass: "jumbotron" }, [
        _c("div", { staticClass: "jumbotron_txtUnit ff_serif" }, [
          _c("h1", { staticClass: "jumbotron_ttl" }, [_vm._v("由数学協会")]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_txtJa" }, [
            _c("span", { staticClass: "fz_20" }, [_vm._v("史上最高")]),
            _vm._v("の"),
            _c("br"),
            _vm._v(
              "\n                                                    自分になるメソッド\n                "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "jumbotron_txtEn ff_serif" }, [
          _vm._v("\n                you learn it"),
          _c("br"),
          _vm._v("\n                for you."),
          _c("br"),
          _vm._v("\n                Your dream"),
          _c("br"),
          _vm._v("\n                life"),
          _c("br"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "jumbotron_art" }, [
          _c("h2", { staticClass: "jumbotron_art_fonts yussugaku" }, [
            _vm._v("yusuugaku"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts creato" }, [
            _vm._v("creato"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts subcon" }, [
            _vm._v("subcon"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts ineividuality" }, [
            _vm._v("ineividuality"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts rightbrain" }, [
            _vm._v("rightbrain"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts merit" }, [
            _vm._v("merit"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts reftbrain" }, [
            _vm._v("reftbrain"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts selfproduce" }, [
            _vm._v("selfproduce"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts statistics" }, [
            _vm._v("statistics"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts communication" }, [
            _vm._v("communication"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts learning" }, [
            _vm._v("learning"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts past" }, [
            _vm._v("past"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts suport" }, [
            _vm._v("suport"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts decision" }, [
            _vm._v("decision"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts welcome" }, [
            _vm._v("welcome"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts thought" }, [
            _vm._v("thought"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts world" }, [
            _vm._v("world"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts taxonomy" }, [
            _vm._v("taxonomy"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts stageup" }, [
            _vm._v("stageup"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts scheme" }, [
            _vm._v("scheme"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts online" }, [
            _vm._v("online"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts association" }, [
            _vm._v("association"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts install" }, [
            _vm._v("install"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts method" }, [
            _vm._v("method"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts morality" }, [
            _vm._v("morality"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts private" }, [
            _vm._v("private"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts success" }, [
            _vm._v("success"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts license" }, [
            _vm._v("license"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts sns" }, [_vm._v("sns")]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts origin" }, [
            _vm._v("origin"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts counseor" }, [
            _vm._v("counseor"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts trouble" }, [
            _vm._v("trouble"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts program" }, [
            _vm._v("program"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts update" }, [
            _vm._v("update"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts school" }, [
            _vm._v("school"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts output" }, [
            _vm._v("output"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts proper" }, [
            _vm._v("proper"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts original" }, [
            _vm._v("original"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "jumbotron_art_fonts time" }, [
            _vm._v("time"),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "js_inview_heading el_verticalLineBox" }, [
      _c("span", { staticClass: "el_verticalLine" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v(
        "\n                        それは、人が互いに理解し合うための方法(メソッド)がこれまでになかったからです。"
      ),
      _c("br"),
      _vm._v(
        "\n                        このプロファイリングメソッドは、創設者の25年による実業実績と、統計学・分類学などの学問を融合させたオリジナルメソッドです。\n                    "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "js_inview_heading el_verticalLineBox" }, [
      _c("span", { staticClass: "el_verticalLine" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "cardB_ttl" }, [
      _c("span", { staticClass: "cardB_ttl_number js_inview_cardB_num" }, [
        _vm._v("01"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "cardB_ttl_letter js_inview_cardB_ttl" }, [
        _vm._v("自己プロデュース"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "cardB_txt js_inview_cardB_txt" }, [
      _vm._v(
        "\n                        自分の在り方、考え方、行動パターンを分析し最速で自己開花する方法を学びます。"
      ),
      _c("br"),
      _vm._v(
        "\n                        プロファイリングを行うことで、自分の変化と進化を体感します。\n                    "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "cardB_ttl" }, [
      _c("span", { staticClass: "cardB_ttl_number js_inview_cardB_num" }, [
        _vm._v("02"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "cardB_ttl_letter js_inview_cardB_ttl" }, [
        _vm._v("自立"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "cardB_txt js_inview_cardB_txt" }, [
      _vm._v(
        "\n                        ビジネス社会において、収益化するメソッドとは必須です。"
      ),
      _c("br"),
      _vm._v(
        "\n                        ビジネスマネジメントの強化や、自立するための自信をつけるプロセスを学びます。\n                    "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "cardB_ttl" }, [
      _c("span", { staticClass: "cardB_ttl_number js_inview_cardB_num" }, [
        _vm._v("03"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "cardB_ttl_letter js_inview_cardB_ttl" }, [
        _vm._v("働くから楽しむの世界"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "bg-base" }, [
      _c(
        "div",
        {
          staticClass:
            "container pt-60 pb-60 pt-md-100 pb-md-100 position_relative",
        },
        [
          _c("div", { staticClass: "js_inview_heading el_verticalLineBox" }, [
            _c("span", { staticClass: "el_verticalLine" }),
          ]),
          _vm._v(" "),
          _c(
            "h2",
            { staticClass: "el_headingA", attrs: { title: "Recommend" } },
            [_vm._v("\n                こんな方におすすめ\n            ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cardCUnit" }, [
            _c("div", { staticClass: "cardC js_inview_cardC" }, [
              _c("h3", { staticClass: "cardC_ttl" }, [
                _vm._v(
                  "\n                        ビジネス編\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "cardC_list" }, [
                _c("li", [_vm._v("上司とうまく付き合いたい")]),
                _vm._v(" "),
                _c("li", [_vm._v("取引先やお客様との交渉が苦手")]),
                _vm._v(" "),
                _c("li", [_vm._v("部下への指導、まとめ方がわからない")]),
                _vm._v(" "),
                _c("li", [_vm._v("集客、クロージング力をつけたい")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cardC js_inview_cardC" }, [
              _c("h3", { staticClass: "cardC_ttl" }, [
                _vm._v(
                  "\n                        パートナー編\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "cardC_list" }, [
                _c("li", [_vm._v("あの人に自分を分かってほしい")]),
                _vm._v(" "),
                _c("li", [_vm._v("理解してくれる最良のパートナーとは")]),
                _vm._v(" "),
                _c("li", [_vm._v("あの人と自分との相性を知りたい")]),
                _vm._v(" "),
                _c("li", [_vm._v("パートナーとの最も幸運な時期はいつ")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cardC js_inview_cardC" }, [
              _c("h3", { staticClass: "cardC_ttl" }, [
                _vm._v(
                  "\n                        子育て編\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "cardC_list" }, [
                _c("li", [_vm._v("子供にとってわかりやすい親になるには")]),
                _vm._v(" "),
                _c("li", [_vm._v("子供のやる気スイッチを押したい")]),
                _vm._v(" "),
                _c("li", [_vm._v("子供の能力を開花させたい")]),
                _vm._v(" "),
                _c("li", [_vm._v("子供の潜在能力を知りたい")]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cardC js_inview_cardC" }, [
              _c("h3", { staticClass: "cardC_ttl" }, [
                _vm._v(
                  "\n                        コミュニケーション編\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "cardC_list" }, [
                _c("li", [_vm._v("自分の考えを上手く表現できない")]),
                _vm._v(" "),
                _c("li", [_vm._v("相手の気持ちや表現に振り回されてしまう")]),
                _vm._v(" "),
                _c("li", [_vm._v("相手の気持ちを理解するには？")]),
                _vm._v(" "),
                _c("li", [_vm._v("自分を分かってくれる人ってどんな人？")]),
              ]),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "js_inview_heading el_verticalLineBox" }, [
      _c("span", { staticClass: "el_verticalLine" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "lh_2" }, [
      _vm._v(
        "\n                    私たちは職場・恋愛・子育てと、全ては人間関係の中で成り立っています。"
      ),
      _c("br"),
      _vm._v(
        "\n                    一人で悩まず、由数学を活用し、ストレスフリーな毎日を過ごしませんか？\n                "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "contD_disc mt-40" }, [
      _c("dt", [_vm._v("受講料"), _c("span", [_vm._v("：")])]),
      _vm._v(" "),
      _c("dd", [_vm._v("３,８００円")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "contD_disc mt-10" }, [
      _c("dt", [_vm._v("時　間"), _c("span", [_vm._v("：")])]),
      _vm._v(" "),
      _c("dd", [_vm._v("２時間")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "el_verticalLineBox el_verticalLineBox__static el_verticalLineBox__long mt-50",
      },
      [_c("span", { staticClass: "js_inview_line el_verticalLine" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "js_inview_heading el_verticalLineBox" }, [
      _c("span", { staticClass: "el_verticalLine" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "el_verticalLineBox el_verticalLineBox__static el_verticalLineBox__long mt-50",
      },
      [_c("span", { staticClass: "js_inview_line el_verticalLine" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }